var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.d{fill:none;}.b,.e,.f{fill:#71778a;}.c{stroke:#fff;}.e,.f{stroke:#fcfcfc;stroke-width:0.5px;}.e{stroke-linecap:round;stroke-linejoin:round;}.g,.h{stroke:none;}.h{fill:#fcfcfc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.458 -672.99)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 38,
    transform: "translate(23.458 672.99)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.266 684.394)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 28,
    height: 16,
    rx: 2,
    transform: "translate(0.192 -0.404)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(11.192 4.596)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 2.5,
    cy: 3,
    rx: 2,
    ry: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(1.646 1.652)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M21.244,11.717H3.417A5.976,5.976,0,0,0,0,8.1V3.614A5.975,5.975,0,0,0,3.417,0H21.244a5.974,5.974,0,0,0,3.416,3.614V8.1a5.98,5.98,0,0,0-3.416,3.612Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M 20.56486701965332 10.7172966003418 C 21.19632339477539 9.34112548828125 22.28389358520508 8.200292587280273 23.66051864624023 7.471771240234375 L 23.66051864624023 4.247654914855957 C 22.28284645080566 3.518585681915283 21.19515609741211 2.376936674118042 20.56450080871582 0.9999968409538269 L 4.096670627593994 0.9999968409538269 C 3.465779066085815 2.37721848487854 2.377940654754639 3.518795967102051 0.9999993443489075 4.247753143310547 L 0.9999993443489075 7.471660137176514 C 2.377752780914307 8.200376510620117 3.465490818023682 9.341227531433105 4.096437931060791 10.7172966003418 L 20.56486701965332 10.7172966003418 M 21.24444961547852 11.7172966003418 L 3.416799306869507 11.7172966003418 C 2.882609367370605 10.10172653198242 1.637609362602234 8.785106658935547 -6.768798925804731e-07 8.104987144470215 L -6.768798925804731e-07 3.61445689201355 C 1.637609362602234 2.934326887130737 2.882609367370605 1.616996884346008 3.416799306869507 -3.130340473944671e-06 L 21.24444961547852 -3.130340473944671e-06 C 21.77863883972168 1.617706894874573 23.02363967895508 2.934326887130737 24.66051864624023 3.61445689201355 L 24.66051864624023 8.104987144470215 C 23.02509880065918 8.784397125244141 21.78009986877441 10.10029697418213 21.24444961547852 11.71657657623291 L 21.24444961547852 11.7172966003418 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.99 8.862)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.532)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,4.112H0V0L5.785,1.129a8.365,8.365,0,0,1,2.542.5l2.372.463V4.112h0c0,1.651-2.4,2.99-5.349,2.99S0,5.763,0,4.112Z",
    transform: "translate(0.297 1.522)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(0.202 0.202)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 5.5,
    cy: 3,
    rx: 5.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 5.5,
    cy: 3,
    rx: 5.25,
    ry: 2.75
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,2.992H0V.969H1.408A7.745,7.745,0,0,1,5.349,0,7.745,7.745,0,0,1,9.29.969H10.7V2.992h0c0,1.652-2.4,2.99-5.349,2.99S0,4.643,0,2.992Z",
    transform: "translate(0.297 3.18)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(0.202 -0.266)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 5.5,
    cy: 4,
    rx: 5.5,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 5.5,
    cy: 4,
    rx: 5.25,
    ry: 3.75
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGrey);
export default __webpack_public_path__ + "static/media/money_grey.56f8dff0e15fb5d76d737b2beb2e355a.svg";
export { ForwardRef as ReactComponent };